import { render, staticRenderFns } from "./CopyrightFormFilesEscalated.vue?vue&type=template&id=542a5e45&scoped=true&"
import script from "./CopyrightFormFilesEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightFormFilesEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightFormFilesEscalated.vue?vue&type=style&index=0&id=542a5e45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a5e45",
  null
  
)

export default component.exports